import ResourceList from "@/components/ResourceList";
import { MapPin } from "@phosphor-icons/react";

export default function Addresses() {
  return (
    <ResourceList
      title="Addresses"
      subtitle="Places that matter"
      resource="addresses"
      icon={MapPin}
      testidPrefix="addresses"
      emptyText="No addresses saved"
      itemTitle={(a) => a.label}
      itemSubtitle={(a) => a.address}
      itemBadge={(a) => a.contact_phone ? <div className="mt-2 text-sm text-[#576A62]">☎ {a.contact_phone}</div> : null}
      fields={[
        { key: "label", label: "Label", required: true, placeholder: "e.g. Mom's home / Hospital" },
        { key: "kind", label: "Type", options: [
          { value: "home", label: "Home" },
          { value: "hospital", label: "Hospital" },
          { value: "clinic", label: "Clinic" },
          { value: "lab", label: "Lab" },
          { value: "other", label: "Other" },
        ] },
        { key: "address", label: "Full address", textarea: true, rows: 2 },
        { key: "contact_name", label: "Contact name" },
        { key: "contact_phone", label: "Contact phone" },
        { key: "notes", label: "Notes", textarea: true },
      ]}
    />
  );
}
